import { css } from "@emotion/react";
import { ArrowRight, BugReport, CheckCircleOutline } from "@material-ui/icons";
import styled, { ThemedCssCreator } from "../../../../config/emotion";
import { StyledCompProps } from "../../../../globalTypes/theme";

export const bugsOverviewContainerCss = css`
  width: 500px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin: 10px;

  @media only screen and (max-width: 812px) {
    width: calc(90vw - 20px);
    margin: 0;
  }
`;

export const bugOverviewContainerCss: ThemedCssCreator = ({ colors }) => css`
  width: 100%;
  padding: 10px;
  display: flex;
  flex-direction: column;

  border-bottom: 1px solid ${colors.bgColor};

  &:last-child {
    border-bottom: none;
  }

  @media only screen and (max-width: 812px) {
    padding: 10px 80px 10px 25px;
  }
`;

export const bugOverviewRowCss = css`
  width: 100%;
  display: flex;
  align-items: center;
`;

export const bugOverviewHeaderCss = css`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`;

export const errorNameCss: ThemedCssCreator = ({ colors }) => css`
  color: ${colors.secondaryColor};
  font-weight: bold;
  margin-right: 10px;
`;

export const errorMessageWrapper = css`
  width: 100%;
  position: relative;
  :before {
    content: "&nbsp;";
    visibility: hidden;
  }
`;

export const errorMessageCss: ThemedCssCreator = ({ colors }) => css`
  text-align: left;
  color: ${colors.primaryColor};
  position: absolute;
  left: 0;
  right: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

type ToggleWithThemeType = StyledCompProps & {
  toggled: boolean;
};

export const StyledArrowRight = styled(ArrowRight)<ToggleWithThemeType>`
  font-size: 25px !important;
  color: ${({ theme }): string => theme.colors.secondaryColor};
  cursor: pointer;

  ${({ toggled }): string | boolean => toggled && "transform: rotate(90deg);"}
`;

export const IconCheck = styled(CheckCircleOutline)<StyledCompProps>`
  font-size: 40px !important;
  color: ${({ theme }): string => theme.colors.save};
`;

export const bugReportButtonContainer = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  button {
    margin-left: 5px;
    height: 30px;
    box-shadow: none;
  }
`;

export const bugReportButtonCss: ThemedCssCreator = ({ colors }) => css`
  width: 30px;
  background-color: ${colors.secondaryColor};
  color: white;
  text-transform: uppercase;
  font-size: 12px;
  border-radius: 10px;
  border: none;
`;

export const StyledBugReportIcon = styled(BugReport)<StyledCompProps>`
  font-size: 25px !important;
  color: ${({ theme }): string => theme.colors.secondaryColor};
  cursor: pointer;
`;

export const BugOverviewContent = styled.div<{ toggled: boolean }>`
  display: ${({ toggled }): string => (toggled ? "flex" : "none")};
  flex-direction: column;
  align-items: flex-start;
`;

export const bugOverviewContentMessage: ThemedCssCreator = ({ colors }) => css`
  margin-top: 10px;
  width: 100%;
  white-space: pre-line;
  color: #8a8a8a;
  font-size: 13px;
  text-align: left;
`;
